import { render, staticRenderFns } from "./ConfirmHandover.vue?vue&type=template&id=1380413e"
import script from "./ConfirmHandover.vue?vue&type=script&lang=js"
export * from "./ConfirmHandover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports